<template>
  <div class="form-group">
    <div class="dropdown">
      <a
        class="cursor-pointer input-group"
        :name="name" 
        :id="id"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span class="form-control"> 
          {{ displayText }} 
        </span>
        <span class="input-group-text">
          <i class="fa fa-caret-down text-secondary" aria-hidden="true"></i>
        </span>
        
      </a>
      <ul
        class="dropdown-menu px-2 py-3"
        :aria-labelledby="name"
        style
      >
        <li v-for="(part) in values" :key="part">
          <a 
            class="dropdown-item border-radius-md" 
            :class="{ 'active': isSelected(part) }"
            @click="elementChanged(part)"
          >
            <i 
              v-if="multiple" 
              class="fa me-2"
              :class="isSelected(part) ? 'fa-check-square' : 'fa-square'"
            ></i>
            {{part.name||part}}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "UIDropdown",
  props: {
    name: String,
    id: String,
    values: Array,
    modelValue: [String, Object, Array],
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedVal: this.multiple 
        ? (Array.isArray(this.modelValue) 
            ? this.modelValue.map(val => this.values && this.values.find(v => v.value === val) || val)
            : (this.modelValue 
                ? [this.values && this.values.find(v => v.value === this.modelValue) || this.modelValue]
                : []))
        : (this.values && this.values.find(val => val.value === this.modelValue) || this.modelValue)
    }
  },
  computed: {
    displayText() {
      if (this.multiple) {
        if (!this.selectedVal || this.selectedVal.length === 0) return 'None';
        return this.selectedVal.map(val => val && val.name || val).join(', ');
      } else {
        return this.selectedVal && this.selectedVal.name || this.selectedVal || 'None';
      }
    }
  },
  emits: ['update:modelValue', 'input'],
  watch: {
    modelValue(newVal) {
      if (this.multiple) {
        this.selectedVal = Array.isArray(newVal) 
          ? newVal.map(val => this.values && this.values.find(v => v.value === val) || val)
          : (newVal ? [this.values && this.values.find(v => v.value === newVal) || newVal] : []);
      } else {
        this.selectedVal = this.values && this.values.find(val => val.value === newVal) || newVal;
      }
    }
  },
  methods: {
    isSelected(part) {
      if (!this.multiple) return false;
      return this.selectedVal.some(val => {
        if (typeof val === 'object' && typeof part === 'object') {
          return val === part || (val.value !== undefined && part.value !== undefined && val.value === part.value);
        }
        return val === part;
      });
    },
    elementChanged(ev) {
      if (this.multiple) {
        const index = this.selectedVal.findIndex(val => {
          if (typeof val === 'object' && typeof ev === 'object') {
            return val === ev || (val.value !== undefined && ev.value !== undefined && val.value === ev.value);
          }
          return val === ev;
        });
        
        if (index > -1) {
          // Remove if already selected
          this.selectedVal = this.selectedVal.filter((_, i) => i !== index);
        } else {
          // Add if not selected
          this.selectedVal = [...this.selectedVal, ev];
        }
        // Emit array of values (extract value property if exists, otherwise the object itself)
        const emitVal = this.selectedVal.map(val => val && val.value !== undefined ? val.value : val);
        this.$emit('update:modelValue', emitVal);
        this.$emit('input', emitVal);
      } else {
        this.selectedVal = ev;
        const emitVal = ev && ev.value !== undefined ? ev.value : ev;
        this.$emit('update:modelValue', emitVal);
        this.$emit('input', emitVal);
      }
    }
  }
};
</script>
